import { effect, inject } from '@angular/core';
import { LocalizedValue } from '@app/models/shared.models';
import { trackUnauthorizedLoad } from '@app/helpers/master-data-unauthorized-load.helper';
import { PersonRoleService } from '@app/services/person-role/person-role.service';
import { AuthStore } from '@app/stores/auth.store';
import {
  patchState,
  signalStore,
  type,
  withHooks,
} from '@ngrx/signals';
import { setEntities, withEntities } from '@ngrx/signals/entities';

const personRoleLoadKey = 'personRole' as const;

export const PersonRoleStore = signalStore(
  { providedIn: 'root' },
  withEntities({ entity: type<LocalizedValue>(), collection: 'personRole' }),
  withHooks((store) => {
    const personRoleService = inject(PersonRoleService);
    const authStore = inject(AuthStore);
    const pendingUnauthorizedLoads = new Set<string>();
    const emptyPersonRoles = { data: [] as LocalizedValue[] };

    const loadPersonRoles = (): void => {
      personRoleService
        .loadPersonRole()
        .pipe(
          trackUnauthorizedLoad(
            personRoleLoadKey,
            pendingUnauthorizedLoads,
            emptyPersonRoles,
          ),
        )
        .subscribe((values) => {
          patchState(
            store,
            setEntities(values.data, { collection: 'personRole' }),
          );
        });
    };

    return {
      onInit() {
        loadPersonRoles();

        let wasLoggedIn = authStore.isLoggedIn();
        effect(() => {
          const loggedIn = authStore.isLoggedIn();
          if (loggedIn && !wasLoggedIn && pendingUnauthorizedLoads.size > 0) {
            loadPersonRoles();
          }
          wasLoggedIn = loggedIn;
        });
      },
    };
  }),
);
